import React from 'react';
import { Button, CircularProgress, Box } from '@mui/material';

const ModernButton = ({
  children,
  loading = false,
  variant = 'contained',
  size = 'small',  // Changed default to small
  sx = {},
  ...props
}) => {
  const getVariantStyles = () => {
    switch (variant) {
      case 'contained':
        return {
          background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
          color: 'white',
          boxShadow: '0 1px 2px 0 rgba(59, 130, 246, 0.2)',
          '&:hover': {
            background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)',
            boxShadow: '0 2px 4px 0 rgba(59, 130, 246, 0.3)',
          },
          '&:disabled': {
            background: 'linear-gradient(135deg, #94a3b8 0%, #64748b 100%)',
            color: 'rgba(255, 255, 255, 0.6)',
          },
        };
      case 'outlined':
        return {
          border: '1px solid',
          borderColor: 'divider',
          color: 'text.primary',
          backgroundColor: 'transparent',
          '&:hover': {
            backgroundColor: 'action.hover',
            borderColor: 'primary.main',
          },
        };
      case 'soft':
        return {
          backgroundColor: 'action.hover',
          color: 'text.primary',
          border: 'none',
          '&:hover': {
            backgroundColor: 'action.selected',
          },
        };
      default:
        return {};
    }
  };

  // Standardized sizing - compact and modern
  const getSizeStyles = () => {
    switch (size) {
      case 'small':
        return {
          fontSize: '0.8125rem',  // 13px
          px: 1.5,                // 12px
          py: 0.5,                // 4px
          minHeight: '28px',
        };
      case 'medium':
        return {
          fontSize: '0.875rem',   // 14px
          px: 2,                  // 16px
          py: 0.75,               // 6px
          minHeight: '32px',
        };
      case 'large':
        return {
          fontSize: '0.9375rem',  // 15px
          px: 2.5,                // 20px
          py: 1,                  // 8px
          minHeight: '36px',
        };
      default:
        return {};
    }
  };

  return (
    <Button
      variant={variant === 'soft' ? 'text' : variant}
      size={size}
      disabled={loading}
      sx={{
        borderRadius: 1.5,
        textTransform: 'none',
        fontWeight: 500,
        transition: 'all 0.15s ease',
        ...getSizeStyles(),
        ...getVariantStyles(),
        ...sx,
      }}
      {...props}
    >
      {loading ? (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <CircularProgress size={14} color="inherit" />
          <span>Loading...</span>
        </Box>
      ) : (
        children
      )}
    </Button>
  );
};

export default ModernButton;
